// extracted by mini-css-extract-plugin
export default {"genericComponent":"GenericComponent_genericComponent__NTyDd","genericImg":"GenericComponent_genericImg__3Nnzc","btnHolder":"GenericComponent_btnHolder__Eoiql"};